import { useState, useEffect, useRef } from "react";

export function useIdleTimer(onIdle, timeout = 10_000) {
  const [idleTime, setIdleTime] = useState(0);
  const lastActiveTimeRef = useRef(Date.now());

  useEffect(() => {
    const reset = () => {
      lastActiveTimeRef.current = Date.now();
      setIdleTime(0);  // resets idle time
    };

    const tick = setInterval(() => {
      const diff = Date.now() - lastActiveTimeRef.current;
      setIdleTime(Math.floor(diff / 1000));  // update every sec

      if (diff >= timeout) {
        onIdle();
        reset();
      }
    }, 1000);

    window.addEventListener("mousemove", reset);
    window.addEventListener("keydown", reset);
    window.addEventListener("mousedown", reset);
    window.addEventListener("touchstart", reset);

    return () => {
      clearInterval(tick);
      window.removeEventListener("mousemove", reset);
      window.removeEventListener("keydown", reset);
      window.removeEventListener("mousedown", reset);
      window.removeEventListener("touchstart", reset);
    };
  }, [onIdle, timeout]);

  return { idleTime };
}
